module.exports = __webpack_public_path__ + "static/img/smart.095b0b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smart.png
// module id = on9k
// module chunks = 1